export default "__VITE_ASSET__CRta40KI__"